import React, {useEffect} from "react";
import LandingLayout from "../../include/landingLayout";
import ForgotPasswordView from "./views/ForgotPasswordView";
import useLogin from "../login/hooks/login.hook";

const ForgotPassword = props => {
    const forgotPasswordHook = useLogin();

    useEffect(() => {

    }, [])

    return (
        <>
            <LandingLayout {...props}>
                <ForgotPasswordView {...props} {...forgotPasswordHook} />
            </LandingLayout>
        </>
    )
}

export default ForgotPassword;
